import {Component} from '@angular/core';

@Component({
  selector: 'app-enrolment-actions-cell',
  templateUrl: './enrolment-actions-cell.html',
  styleUrl: './enrolment-actions-cell.scss',
  standalone: false,
})
export class EnrolmentActionsCell {

  constructor() { }

  confermaRifiutaTrasferimento(event: Event, isApprove: boolean): void {
    event.stopPropagation();
    const action = isApprove ? 'approvare' : 'rifiutare';
    alert(`Hai scelto di ${action} la richiesta di presa in carico del paziente.`);
  }

}
